<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NJk3R0/tc-custom/9781685502348.jpg?1723406024274" alt="This image is the cover for the book The Lusty Journey of Perseus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Lusty Journey of Perseus
      </h1>
      <p class="bookDescription body article font2">
        <p>You’ve never heard the story of Perseus and Medusa told quite like this before!<br/><br/>At just nineteen, the handsome and naive Perseus is given a devastating choice: venture out into the world for the first time to slay the monster Medusa, or watch his mother be forcibly married to his homeland’s tyrannical king. Raised on a small island nation where most everyone goes naked and the main activity is fishing, Perseus is ill-prepared for a quest that includes any sort of danger.<br/><br/>Fortunately, he has the gods on his side. After a sexy romp with the Greek god Hermes, he’s given both instructions and an invaluable gift: winged sandals that allow him to fly.<br/><br/>When he teams up with a Corinthian prince who wins his heart, Perseus embarks on one of the great adventures of the ages. Will Perseus be able to save his mother, slay the monster, and live happily ever after with his prince?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Arthur Griffin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dc484c8